import { render, staticRenderFns } from "./MemoApprove.vue?vue&type=template&id=3b88a2be&"
import script from "./MemoApprove.vue?vue&type=script&lang=js&"
export * from "./MemoApprove.vue?vue&type=script&lang=js&"
import style0 from "./MemoApprove.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports